import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'

export const Column = styled(({ flexDirection, padding, ...props }) => <BaseGrid {...props} />)`
  &.MuiGrid-root {
    margin: 0;
    display: flex;
    flex-direction: ${props => props.flexDirection || 'column'};
    flex-wrap: wrap;
    justify-content: space-between;
  }
  &.MuiGrid-root:first-child {
    padding: ${props => props.padding};
  }
`

export const Row = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
    max-width: ${props => props.maxWidth};
    width: ${props => props.width};
  }
`

export const Root = styled('div')`
  width: 100%;
`
